import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react'
import {
    // TopWrapperVideo,
    // TopWrapperVideoContent,
    VideoContent,
    VideoPlayerWrapper,
    VideoWrapper
} from '../../../style/VideoStyle';
import Button from '../../../components/button';
import Navigation from '../../../components/Navigation/Navigation';
import { FormWrapPopup, MainWrapper, TopWrapper } from '../../../style/DasboardMain';
import { useSearchParams } from 'react-router-dom';
import {$apiV1, VIDEO_SERVICE_URL} from '../../../config/api';
import { getVideoName, groupEventsByTeam } from './helpers';
import { EventsPanel } from './ui/EventsPanel';
import { VideoPlayer } from './ui/VideoPlayer';
import Modal from "../../../components/modal/index";
import TextInput from '../../../components/inputs/TextInput';
// import { SelectDropdown } from '../../../style/Global';
import IntroText from "../../../components/introText/index";
import { Dropdown, DropdownButton, DropdownContent, DropdownItem } from './ShotsPlayer';

import arrowIconUp from "../../../images/up.svg";
import arrowIconDown from "../../../images/down.svg";
import { useSelector } from 'react-redux';
import debounce from 'lodash.debounce';
import { useLexicon } from '../../../hooks/useLexicon';
import { useNotification } from '../../../components/notification/useNotification';
import { NotificationList } from '../../../components/notification/NotificationList';
import { trackPlaylistAction } from '../../../tracking';

export const VideoListUpdated = () => {
    const [searchParams] = useSearchParams();
    const l = useLexicon();
    const title = searchParams.get('title');
    const { offset_range_begin = 10, offset_range_end = 10 } = useSelector(state => state.user.userProfile);

    const { notifications, addNotification, removeNotification } = useNotification();

    const [countEpisode, setCountEpisode] = useState(0);
    const [countMatches, setCountMatches] = useState(0);
    const [videoCutsServer, setVideoCutsServer] = useState([]);
    const [videoCuts, setVideoCuts] = useState([]);
    const [videoCutsForHandleVideo, setVideoCutsForHandleVideo] = useState([]);
    const [videoHref, setVideoHref] = useState('');
    const [videoSecond] = useState(0);

    const [loadingVideo, setLoadingVideo] = useState(false);

    const [openAddVideo, setOpenAddVide] = useState(false);
    const [folderName, setFolderName] = useState("");

    const [userPlaylists, setUserPlaylists] = useState([]);
    const [selectedPlaylist, setSelectedPlaylist] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [loadingAddPlaylist, setLoadingAddPlaylist] = useState(false);

    const [record, setRecord] = useState(null);
    const [recordTime, setRecordTime] = useState(null);

    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const currentVideoIndexRef = useRef(0);
    const [currentVideo, setCurrentVideo] = useState(null);
    const [disabledNext, setDisabledNext] = useState(true);
    const [disabledPrev, setDisabledPrev] = useState(true);

    const [loadingDownloadCuts, setLoadingDownloadCuts] = useState(false);

    const [loadingMarkers, setLoadingMarkers] = useState(true);

    const [videoTitle, setVideoTitle] = useState("");

    const videoPlayerRef = useRef(null);

    const selectedEvents = useMemo(() => {
        if (videoCuts.length > 0) {
            return videoCuts.filter(item => !item.braker && item.checked);
        }
        return [];
    }, [videoCuts]);

    useEffect(() => {
        console.log("useEffect");
        const getUserPlaylists = async () => {
            try {
                const res = await $apiV1.get('/users/playlists');
                setUserPlaylists(res.data);
            } catch (e) {
                console.log('get user playlists err', e.message);
            }
        }

        getUserPlaylists();
    }, [])

    useEffect(() => {
        const markers = searchParams.get('markers');

        const getMatchMarkers = async (events) => {
            setLoadingMarkers(true);
            try {
                const response = await $apiV1.post('/stats/markers_search', {
                    markers: events.split(','),
                    video_homography: true,
                    video_homography_timeline: true,
                    video_homography_timeline_window: 3,
                    video_homography_timeline_fill: events.split(',').length === 1,
                })
                const data = await response.data;
                if (data) {
                    const groupedData = groupEventsByTeam(response.data.events)
                    setCountEpisode(data.count);
                    setCountMatches(groupedData.length);
                    setVideoCutsServer(groupedData);
                }
            } catch (e) {
                console.log('get video cuts err', e.message);
            } finally {
                setLoadingMarkers(false);
            }
        }

        if (markers) {
            getMatchMarkers(markers);
        }
    }, [searchParams]);

    const debouncedPlayVideo = useCallback(debounce(handlePlayVideo, 300), [])

    useEffect(() => {
        const markers = getPrepearedMarkers(videoCutsServer)
        setVideoCuts(markers);
        let videoSource = videoCutsForHandleVideo?.[currentVideoIndex] ?? currentVideo;
        if (videoSource) {
            debouncedPlayVideo(videoSource.video, videoSource.second, videoSource, null, offset_range_begin, offset_range_end);
        }
    }, [videoCutsServer, offset_range_begin, offset_range_end]);

    useEffect(() => {
        const markers = getPrepearedMarkers(videoCutsServer)
        setVideoCutsForHandleVideo(markers);
    }, [videoCutsServer])

    useEffect(() => {
        let videoSource = videoCutsForHandleVideo[currentVideoIndex];
        if (videoSource?.braker) {
            setCurrentVideoIndex(currentVideoIndex + 1);
            return
        }
        if (!videoSource) return;
        setDisabledPrev(currentVideoIndex === 0);
        setDisabledNext(currentVideoIndex >= videoCutsForHandleVideo.length - 1);
        handlePlayVideo(videoSource.video, videoSource.second, videoSource);
    }, [currentVideoIndex, videoCutsForHandleVideo]);

    function getPrepearedMarkers(videos) {
        if (!videos?.length) return []

        const allMarkers = videos?.sort((a, b) => new Date(b.match.date) - new Date(a.match.date)).reduce((res, videoCut) => {
            if (videoCut?.markers?.length > 0) {
                res.push({
                    braker: true,
                    key: Math.random(),
                    markers: videoCut.markers,
                    match: videoCut.match,
                });
                const tmp = [...videoCut.markers];
                res.push(...tmp.sort((a, b) => {
                    if (a?.second && b?.second && +a.second > +b.second) {
                        return 1;
                    }
                    if (a?.second && b?.second && +a.second < +b.second) {
                        return -1;
                    }
                    return 0;
                }));
            }
            return res;
        }, []);
        const preparedMarkers = allMarkers
            ?.map((item) => {
                if (item?.braker) {
                    return { ...item, checked: false }
                }
                return {
                    ...item,
                    checked: false,
                    title: getVideoName(item, { start: offset_range_begin, end: offset_range_end }) ?? '',
                }
            })

        return preparedMarkers;
    }

    async function handlePlayVideo(
        link,
        second,
        video,
        idx,
        range_begin,
        range_end
    ) {
        try {
            if (idx) {
                setCurrentVideoIndex(idx);
                return;
            }
            setLoadingVideo(true);

            setCurrentVideo(video);
            setRecord(video);

            let currentOffSets = { start: range_begin ?? offset_range_begin, end: range_end ?? offset_range_end }

            // set offset
            if (+video?.second >= 2700 && (currentOffSets.start === 10 && currentOffSets.end === 10)) {
                currentOffSets = { start: 10, end: 25 };
            }

            if (link) {
                const url = `${VIDEO_SERVICE_URL}/cut`;
                const response = await fetch(url, {
                    body: JSON.stringify({
                        offset_range_begin: currentOffSets.start,
                        offset_range_end: currentOffSets.end,
                        path: decodeURI(link),
                        start: Math.round(second),
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                });
                const json = await response.json();
                if (json.data && json.data.path) {
                    setVideoHref(json.data.path);
                }

                if (json.errors && json.errors.length) {
                    alert(`Errors: ${json.errors.join(" , ")}`)
                }
            }
        } catch (e) {
            alert(`Get video error, ${e.message}`);
            console.log('get cut video err', e.message);
        } finally {
            setLoadingVideo(false);
        }
    };

    const toggleCheckCut = (checked, event) => {
        let cuts = [...videoCuts];

        const cutIndex = cuts.findIndex((tab) => tab.id === event.id);
        if (cutIndex >= 0) {
            if (cutIndex >= 0) {
                cuts[cutIndex].checked = checked;
            }
        }
        setVideoCuts(cuts);
    }

    const toggleAllEventsOnMatch = (checked, events) => {
        events?.forEach((event) => {
            if (event.video) {
                toggleCheckCut(checked, event);
            }
        })
    }

    const toggleAllEvents = (checked) => {
        toggleAllEventsOnMatch(checked, videoCuts)
    }

    const handleEmailChange = (newValue) => {
        setFolderName(newValue);
    };

    // const getCutVideo = async (params) => {
    //     const result = await $apiV1.post(
    //         `${VIDEO_SERVICE_URL}/cut_video/`,
    //         params,
    //     );

    //     return result
    // }

    const addNewFolder = async () => {

        console.log("clicked add new folder   record   ", record, "  recordTime  ", recordTime);
        

        try {
            setLoadingAddPlaylist(true);
            let playlist;

            if (!selectedPlaylist) {
                // First API request to create a new folder
                const createFolderResponse = await $apiV1.post(`/users/playlists`,
                    { title: folderName },
                );
                playlist = createFolderResponse.data;
                trackPlaylistAction({
                    action: 'create',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || folderName,
                    sourceSurface: 'video',
                });
                setUserPlaylists(prev => [playlist, ...prev])
            } else {
                playlist = selectedPlaylist;
            }

            setOpenAddVide(!openAddVideo);

            if (record?.id && recordTime?.startTime && recordTime?.endTime) {
                const params = {
                    end_second: +(+recordTime.endTime).toFixed(0),
                    start_second: +(+recordTime.startTime).toFixed(0),
                    event_id: record.id,
                    title: videoTitle || `Record from ${recordTime.startTime.toFixed(0)} to ${recordTime.endTime.toFixed(0)}`
                }

                console.log('params', params);
                // await getCutVideo(params);
                await $apiV1.post(`/users/playlists/${playlist.id}/add`,
                    [params],
                );
                trackPlaylistAction({
                    action: 'video_add',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || null,
                    metadata: {
                        clip_end_second: params.end_second,
                        clip_start_second: params.start_second,
                        event_id: record?.id,
                    },
                    sourceSurface: 'video',
                });
                return
            }

            // Ensure selectedCheckboxes is an array of event_ids
            const events = selectedEvents?.length > 0
                ? selectedEvents.map((event) => ({
                    event_id: event.id,
                    title: event.title,
                }))
                : [];

            if (events?.length !== 0) {
                // Second API request to add events to the newly created folder
                await $apiV1.post(`/users/playlists/${playlist.id}/add`,
                    events,
                );
                trackPlaylistAction({
                    action: 'video_add',
                    entityId: playlist?.id,
                    entityLabel: playlist?.title || null,
                    metadata: {
                        added_events_count: events.length,
                        event_ids: events.map((event) => event?.event_id).filter(Boolean),
                    },
                    sourceSurface: 'video',
                });
                videoCuts?.map(item => toggleCheckCut(false, item));
            }

            // You can handle the response of the second API request here if needed
            // setCheck(addEventsResponse.data);
            // setOpenAddVide(!openAddVideo);
        } catch (error) {
            console.error("Error processing request:", error);
        } finally {
            setLoadingAddPlaylist(false);
        }
    };

    const handleSelectChange = (value) => {
        console.log("handleSelectChange", value);
        setSelectedPlaylist(value);
    };

    const addRecordToPlaylist = () => {
        console.log("addRecordToPlaylist");
        setOpenAddVide(true);
    }

    const handlePrevVideo = () => {
        if (currentVideoIndex > 0) {
            let idx = currentVideoIndex - 1
            let videoSource = videoCutsForHandleVideo[idx];
            if (videoSource?.braker) {
                setCurrentVideoIndex(idx - 1);
                return
            }
            setCurrentVideoIndex(idx);
        }
    };

    const handleNextVideo = () => {
        if (currentVideoIndex < videoCutsForHandleVideo.length - 1) {
            let idx = currentVideoIndex + 1
            let videoSource = videoCutsForHandleVideo[idx];
            if (videoSource?.braker) {
                setCurrentVideoIndex(idx + 1);
                return
            }
            setCurrentVideoIndex(idx);

        }
    };


    const prepeareCutsForServer = (data) => {
        // eslint-disable-next-line consistent-return,array-callback-return
        const cuts = Object.entries(data).map(([key, values]) => {
            const path = decodeURI(values.video);
            const start = Math.round(+values.second) - offset_range_begin < 0 ? 0 : Math.round(+values.second) - offset_range_begin;
            return {
                end: Math.round(+values.second) + offset_range_end,
                path,
                start,
            };
        });
        return cuts;
    };

    const handleDownloadSelectedCuts = async () => {
        setLoadingDownloadCuts(true);
        try {
            let data = [];
            if (selectedEvents?.length === 0 && videoCuts?.length > 0) {
                data = videoCuts?.filter(item => !Boolean(item.braker))
            } else {
                data = selectedEvents;
            }
            const cuts = prepeareCutsForServer(
                data.filter((item) => Boolean(item.video)),
            );
            if (cuts.length > 0) {
                const controller = new AbortController();
                addNotification(`Fetching clips. Please don't close or refresh the page till the download is completed.`, "info", controller);
                document.body.classList.add("loading-cursor");
                const url = `${VIDEO_SERVICE_URL}/batch/cut/zip`;
                videoPause();
                const response = await fetch(url, {
                    body: JSON.stringify(cuts),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    signal: controller.signal
                });
                const json = await response.json();
                if (json.data && json.data.path) {
                    const a = document.createElement('a');
                    a.href = json.data.path;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
        
                if (json.errors && json.errors.length) {
                    addNotification(`Get zip archive error: ${json.errors.join(" , ")}`, 'error')
                }

            } else {
                addNotification('There are no videos available for download', 'error')
            }
        } catch (e) {
            addNotification(`Get zip archive error, ${e.message}`, 'error')
        } finally {
            setLoadingDownloadCuts(false);
            document.body.classList.remove("loading-cursor");
        }
    };

    const handleDownloadSelectedCutsInOneClip = async () => {
        setLoadingDownloadCuts(true);
        try {
            let data = [];
            if (selectedEvents?.length === 0 && videoCuts?.length > 0) {
                data = videoCuts?.filter(item => !Boolean(item.braker))
            } else {
                data = selectedEvents;
            }
            const cuts = prepeareCutsForServer(
                data.filter((item) => Boolean(item.video)),
            );
            if (cuts.length > 0) {
                const controller = new AbortController();
                addNotification(`Fetching clips in one clip. Please don't close or refresh the page till the download is completed.`, "info", controller);
                document.body.classList.add("loading-cursor");
                const url = `${VIDEO_SERVICE_URL}/batch/cut/video`;
                videoPause();
                const response = await fetch(url, {
                    body: JSON.stringify(cuts),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    signal: controller.signal,
                });
                const json = await response.json();
                if (json.data && json.data.path) {
                    const a = document.createElement('a');
                    a.href = `${json.data.path}?download=true`;
                    a.rel = 'noopener noreferrer';
                    a.download = json.data.hash;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    videoPlay();
                }
        
                if (json.errors && json.errors.length) {
                    addNotification(`Get video error: ${json.errors.join(" , ")}`, 'error')
                    videoPlay();
                }
            } else {
                addNotification('There are no videos available for download', 'error')
            }
        } catch (e) {
            addNotification(`Get zip archive error, ${e.message}`, 'error')
        } finally {
            setLoadingDownloadCuts(false);
            document.body.classList.remove("loading-cursor");
        }
    };

    const modal = (
        <Modal isOpen={openAddVideo} setIsOpen={setOpenAddVide} closeIc>
            <h1>
                {
                    record && recordTime?.startTime && recordTime?.endTime
                        ? l(1027)
                        : `Add ${selectedEvents?.length} events to Playlist `
                }
            </h1>
            <FormWrapPopup style={{ marginTop: "20px" }}>
                <Dropdown>
                    <DropdownButton
                        onClick={() => setShowDropdown(!showDropdown)}
                    >
                        {!selectedPlaylist
                            ? `${l(1088)}`
                            : `${selectedPlaylist?.title}`}
                        <img src={showDropdown ? arrowIconUp : arrowIconDown} />
                    </DropdownButton>
                    <DropdownContent $show={showDropdown}>
                        {userPlaylists.map((item) => (
                            <DropdownItem
                                key={item.id}
                                selected={item.id === selectedPlaylist?.id}
                                onClick={() => handleSelectChange(item)}
                            >
                                {item.title}
                            </DropdownItem>
                        ))}
                    </DropdownContent>
                </Dropdown>
                <TextInput
                    label={l(1089)}
                    type={"text"}
                    value={folderName}
                    placeholder={l(1090)}
                    onChange={handleEmailChange}
                />
                 <TextInput
                    label={l(1108)}
                    type={"text"}
                    value={videoTitle}
                    placeholder={l(1108)}
                    onChange={setVideoTitle}
                />
            </FormWrapPopup>
            <Button
                style={{ zIndex: 1 }}
                title="Add to playlist"
                size={"full"}
                onClick={() => addNewFolder()}
                disabled={loadingAddPlaylist}
            />
        </Modal>
    );

    const videoPause = () => {
        videoPlayerRef.current?.pause();
    };

    const videoPlay = () => {
        videoPlayerRef.current?.play();
    };

    const toggleVideo = () => {
        videoPlayerRef.current?.togglePlay();
    };

    return (
        <MainWrapper>
            <Navigation />
            <VideoWrapper className={
                localStorage.getItem("navigationOpen") === "true"
                    ? ""
                    : "fullWidthPage"
            }>
                <TopWrapper>
                    <IntroText title={title} />
                </TopWrapper>
                <VideoPlayerWrapper>
                    <EventsPanel
                        toggleAllEvents={toggleAllEvents}
                        countEpisodes={countEpisode}
                        countMathes={countMatches}
                        videoCuts={videoCuts}
                        handlePlayVideo={handlePlayVideo}
                        toggleCheckCut={toggleCheckCut}
                        toggleAllEventsOnMatch={toggleAllEventsOnMatch}
                        selectedEventsCount={selectedEvents?.length || 0}
                        onOpenAddPlaylistModal={(bool) => {
                            setRecord(null);
                            setOpenAddVide(bool)
                        }}
                        currentVideoIndex={currentVideoIndex}
                        loadingDownloadCuts={loadingDownloadCuts}
                        handleDownloadSelectedCuts={handleDownloadSelectedCuts}
                        handleDownloadSelectedCutsInOneClip={handleDownloadSelectedCutsInOneClip}
                        loadingMarkers={loadingMarkers}
                    />

                    <VideoContent>
                        <VideoPlayer
                            ref={videoPlayerRef}
                            styleWrapper={{ width: '95%' }}
                            video={videoHref}
                            toSecond={videoSecond}
                            playNextVideo={handleNextVideo}
                            playPrevVideo={handlePrevVideo}
                            videos={videoCuts}
                            loading={loadingVideo}
                            record={record}
                            setRecord={setRecord}
                            recordTime={recordTime}
                            setRecordTime={setRecordTime}
                            addRecordToPlaylist={addRecordToPlaylist}
                            disabledNext={disabledNext}
                            disabledPrev={disabledPrev}
                            activeEvent={record}
                            eventOffsetBegin={offset_range_begin}
                        />
                    </VideoContent>
                </VideoPlayerWrapper>
            </VideoWrapper>
            {modal}
            {/* display notifications */}
            <NotificationList
                notifications={notifications}
                onClose={removeNotification}
            />
        </MainWrapper>
    )
}
